module.exports = __webpack_public_path__ + "static/otm_recruit_candidates-3c5934646d1c23e8ad43096ab6955aa3.png";